import _ from "lodash";
import request from "@/method/request";
import { data2_3 } from './data';
import { message } from "antd";

export const compute = data => {
    const rowNextData = ['nextJan', 'nextFeb', 'nextMar'];
    const numConvert = (num = 0) => {
        num = Number(num || "0")
        return num
    }

    // 计算一
    const rowNum = [0, 1, 5, 6, 7, 9, 11, 13, 15, 17, 21, 24, 25, 26, 28, 29, 30, 31];
    const rowNameData = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    for (let index = 0; index < rowNum.length; index++) {
        data[rowNum[index]].whole = rowNameData.reduce((a, b) => {
            a += numConvert(data[rowNum[index]][b]);
            return a
        }, 0);
        data[rowNum[index]].nextQ1 = rowNextData.reduce((a, b) => {
            a += numConvert(data[rowNum[index]][b]);
            return a
        }, 0);
        (data[rowNum[index]].whole).toFixed(2);
        (data[rowNum[index]].nextQ1).toFixed(2);
    }
    // 计算二
    const nameData = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'nextJan', 'nextFeb', 'nextMar', 'whole', 'nextQ1'];

    for (let index = 0; index < nameData.length; index++) {
        // 提前计算毛利润 GOP
        //  GOP
        data[22][nameData[index]] = (numConvert(data[8][nameData[index]]) == 0 ? 0 : numConvert(data[21][nameData[index]]) / numConvert(data[8][nameData[index]])).toFixed(3);
        //  盈亏平衡点/总费用
        data[23][nameData[index]] = (numConvert(data[8][nameData[index]]) - numConvert(data[21][nameData[index]])).toFixed(2);


        // 客房率
        data[2][nameData[index]] = (numConvert(data[0][nameData[index]]) == 0 ? 0 : numConvert(data[1][nameData[index]]) / numConvert(data[0][nameData[index]])).toFixed(3);
        // 平均房价
        data[3][nameData[index]] = (numConvert(data[1][nameData[index]]) == 0 ? 0 : numConvert(data[5][nameData[index]]) / numConvert(data[1][nameData[index]])).toFixed(2);
        // 平均收入
        data[4][nameData[index]] = (numConvert(data[0][nameData[index]]) == 0 ? 0 : numConvert(data[5][nameData[index]]) / numConvert(data[0][nameData[index]])).toFixed(2);
        // 总收入
        data[8][nameData[index]] = (numConvert(data[7][nameData[index]]) + numConvert(data[6][nameData[index]]) + numConvert(data[5][nameData[index]])).toFixed(2);
        // 客房部门利润百分比
        data[10][nameData[index]] = (numConvert(data[5][nameData[index]]) == 0 ? 0 : numConvert(data[9][nameData[index]]) / numConvert(data[5][nameData[index]])).toFixed(3);
        // 餐饮部门利润百分比
        data[12][nameData[index]] = (numConvert(data[6][nameData[index]]) == 0 ? 0 : numConvert(data[11][nameData[index]]) / numConvert(data[6][nameData[index]])).toFixed(3);
        // 食品成本百分比
        data[14][nameData[index]] = (numConvert(data[6][nameData[index]]) == 0 ? 0 : numConvert(data[13][nameData[index]]) / numConvert(data[6][nameData[index]])).toFixed(3);
        // 人力资源成本
        data[16][nameData[index]] = (numConvert(data[8][nameData[index]]) == 0 ? 0 : numConvert(data[15][nameData[index]]) / numConvert(data[8][nameData[index]])).toFixed(3);
        // 能源成本
        data[18][nameData[index]] = (numConvert(data[8][nameData[index]]) == 0 ? 0 : numConvert(data[17][nameData[index]]) / numConvert(data[8][nameData[index]])).toFixed(3);
        // 其他费用成本
        data[19][nameData[index]] = (numConvert(data[23][nameData[index]]) - numConvert(data[17][nameData[index]]) - numConvert(data[15][nameData[index]]) - numConvert(data[13][nameData[index]])).toFixed(2);
        // 其他费用成本率
        data[20][nameData[index]] = (numConvert(data[8][nameData[index]]) == 0 ? 0 : numConvert(data[19][nameData[index]]) / numConvert(data[8][nameData[index]])).toFixed(3);
        // 总收费
        data[27][nameData[index]] = (numConvert(data[26][nameData[index]]) + numConvert(data[25][nameData[index]]) + numConvert(data[24][nameData[index]])).toFixed(2);
    }
    return data;
}

export const saveAllData = async (year) => {
    // 获取所有酒店 
    const { data: { hotels } } = await request('/getHotels');
    for (let i = 0; i < hotels.length; i++) {
        const item = hotels[i];
        //  获取当前酒店数据   
        const dataDefault = _.cloneDeep(data2_3);
        let data = dataDefault.filter((x, i) => i != 0);
        let dataSelect = dataDefault.filter((x, i) => i == 0);
        const { data: x, msg } = await request(`/_2_3_info?year=${year}&comid=${item.id}`);
        if (x && x.length > 0) {
            data = x.filter((x, i) => i != 0);
            dataSelect = x.filter((x, i) => i == 0);
        }
        if (msg.last && msg.last.length) {
            data = msg.last.filter((x, i) => i != 0).map((v, i) => {
                delete v.id;
                delete v.month;
                if (data[i].id) v.id = data[i].id;
                return {
                    ...v,
                    'nextJan': _.get(msg.data2_1, `${i + 1}.Jan`),
                    'nextFeb': _.get(msg.data2_1, `${i + 1}.Feb`),
                    'nextMar': _.get(msg.data2_1, `${i + 1}.Mar`),
                }
            });
            dataSelect = msg.last.filter((x, i) => i == 0).map((v, i) => {
                delete v.id;
                delete v.month;
                if (dataSelect[i].id) v.id = dataSelect[i].id;
                return v
            });
        }
        data = compute(data);
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify([...dataSelect, ...data].map(x => ({ ...x, year, comid: item.id }))));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        };
        await request('/add_2_3', headres);
    }
    message.success('保存成功！');
}


// WEBPACK FOOTER //
// ./src/components/table/2-Analysis/2-3/compute.js